import { classicBusinessProjectFormRoute } from '@jira/router-routes__business-form-routes/src/classicBusinessProjectFormRoute.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { getProjectViewResources } from '@jira/router-resources__business-common/src/getBusinessProjectResources.tsx';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';
// Planning to create a new layout for Jira business. Can remove if team decides to use existing layout
// eslint-disable-next-line jira/import/no-restricted-import
import { businessProjectLayout } from '@jira/platform__layouts-business-project-layout/src/index.tsx';
import { ThemedLazySkeleton } from '@jira/platform__project-theme-components/src/ui/ThemedLazySkeleton.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { formPageEntrypoint } from './ui/form/index.tsx';

export const classicBusinessProjectFormRouteEntry: Route = createEntry(
	classicBusinessProjectFormRoute,
	() => ({
		group: 'classic-business',
		ufoName: 'jwm.form-directory-view',
		layout: businessProjectLayout,
		skeleton: ThemedLazySkeleton,

		navigation: {
			menuId: MenuIdProjects,
			horizontal: AsyncHorizontalNavJira,
		},

		resources: getProjectViewResources(),
		entryPoint: () => formPageEntrypoint,
		supportsPreviewPanel: true,
		supportsProjectTheme: 'contoured',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
